import { Progress } from "antd";
import { Popover, Tag } from "antd";
import _ from "lodash";
import React from "react";
import styled from "styled-components";

import { Text } from "@components/Text";

const Container = styled.div`
  display: grid;
  gap: 16px;
  grid-template-columns: 1fr 1fr;
  flex-shrink: 0;
`;

const ContainerBlock = styled.div`
  width: 100%;
  height: 100%;
  padding: 16px;
  /* gap: 16px; */
  border-radius: 16px;
  background: white;
  display: flex;
  flex-direction: column;
  /* justify-content: space-between; */
  background: white;
  box-sizing: border-box;
  overflow: scroll;
  height: 368px;
`;

const ContainerBlockHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

const ContainerProgress = styled.div`
  display: grid;
  align-items: center;
  grid-template-columns: 200px 1fr 90px;
  padding: 8px 0px;
`;

const TableHeaderContainer = styled.div`
  display: grid;
  grid-template-columns: 200px 95px 95px 95px 95px 95px 50px;
  width: max-content;
  background: #f6f6f6;
  padding: 8px 32px;
  border-top-right-radius: 8px;
  border-top-left-radius: 8px;
  box-sizing: border-box;
`;

const TableCellContainer = styled.div`
  display: grid;
  grid-template-columns: 200px 95px 95px 95px 95px 95px 50px;
  width: max-content;
  padding: 0px 32px;
  border-top-right-radius: 8px;
  border-top-left-radius: 8px;
  box-sizing: border-box;
`;

const TableHeader = styled.div`
  font-weight: 600;
  font-size: 14px;
  text-align: ${({ align = "center" }) => align};
`;

const TableCell = styled.div`
  font-size: 14px;
  padding: 12px 0px;
  text-align: ${({ align = "center" }) => align};
`;

export const OverviewTableView = ({ overviewTableViewData = null }) => {
  const customerTableView = _.get(overviewTableViewData, ["customerTableView"]);
  console.log("customerTableView :>> ", customerTableView);
  const diskQuotaData = _.get(overviewTableViewData, ["diskQuota"]);

  const totalDiskQuota = _.chain(overviewTableViewData)
    .get(["diskQuota"])
    .sumBy("totalSize")
    .round(2)
    .value();

  const maxDiskQuota = _.chain(overviewTableViewData)
    .get(["diskQuota"])
    .sumBy("quotaSize")
    .value();

  const getProgressColor = ({ processPercentage }) => {
    console.log("processPercentage :>> ", processPercentage);
    if (processPercentage > 80) {
      return {
        "0%": "#FF8E2B",
        "100%": "#E10004",
      };
    }
    return {
      "0%": "#00CC99",
      "100%": "#75B161",
    };
  };

  return (
    <Container>
      <ContainerBlock>
        <ContainerBlockHeader>
          <Text fontSize={"20px"} fontWeight="600">
            Disk Quota
          </Text>
          <Text fontSize={"20px"} fontWeight="600">
            {totalDiskQuota} GB / {maxDiskQuota} GB
          </Text>
        </ContainerBlockHeader>
        {/* <WrapperContainerProgress> */}
        {_.map(diskQuotaData, (item, index) => {
          const name = _.get(item, ["name"]);
          const percentage = _.get(item, ["progressPercentage"]);
          const quotaSize = _.get(item, ["quotaSize"]);
          const totalSize = _.get(item, ["totalSize"]);
          const progressColor = getProgressColor({
            processPercentage: percentage,
          });

          return (
            <ContainerProgress key={index}>
              <Text fontSize={"14px"} fontWeight="400">
                {name}
              </Text>
              <Progress
                showInfo={false}
                status="active"
                percent={percentage}
                strokeColor={progressColor}
              />
              <Text align="end" fontSize={"10px"} fontWeight="400">
                {_.round(totalSize, 2)} GB / {quotaSize} GB
              </Text>
            </ContainerProgress>
          );
        })}
        {/* </WrapperContainerProgress> */}
      </ContainerBlock>
      <ContainerBlock style={{ overflow: "scroll", gap: 0 }}>
        <TableHeaderContainer>
          <TableHeader align="start">Name</TableHeader>
          <TableHeader>Projects</TableHeader>
          <TableHeader>Campaigns</TableHeader>
          <TableHeader>Devices</TableHeader>
          <TableHeader>Medias</TableHeader>
          <TableHeader>Active Media</TableHeader>
          <TableHeader>Online</TableHeader>
        </TableHeaderContainer>
        {_.map(customerTableView, (item, index) => {
          const name = _.get(item, ["name"]);
          const totalProjects = _.get(item, ["totalProjects"]);
          const totalCampaigns = _.get(item, ["totalCampaigns"]);
          const totalDevices = _.get(item, ["totalDevices"]);
          const totalMedias = _.get(item, ["totalMedias"]);
          const totalActiveMedia = _.get(item, ["totalActiveMedia"]);
          const totalOnlineDevice = _.get(item, ["totalOnlineDevice"]);

          return (
            <TableCellContainer
              key={index}
              style={{
                borderBottom: "1px solid #f6f6f6",
              }}
            >
              <TableCell align="start">{name}</TableCell>
              <TableCell>{totalProjects}</TableCell>
              <TableCell>{totalCampaigns}</TableCell>
              <TableCell>{totalDevices}</TableCell>
              <TableCell>{totalMedias}</TableCell>
              <TableCell>{totalActiveMedia}</TableCell>
              <TableCell>
                <Tag color={"success"}>{totalOnlineDevice}</Tag>
              </TableCell>
            </TableCellContainer>
          );
        })}
      </ContainerBlock>
    </Container>
  );
};
